// Loads Employee IDs and Names via backend proxy (Graph) from sheet "EmployeeID"

let cachedEmployees = null;
let loadError = null;

export const hasEmployeeDirectoryError = () => !!loadError;

export async function loadEmployees() {
	if (cachedEmployees) return cachedEmployees;
	if (loadError) throw loadError;

	try {
		
		const resp = await fetch('/employee-directory.json', { headers: { 'Accept': 'application/json' } });
		if (!resp.ok) throw new Error(`Failed to load employee-directory.json: ${resp.status}`);
		const data = await resp.json();
		
		const list = (Array.isArray(data) ? data : []).map((row, index) => {
			const employeeId = String(row.employeeId || '').trim();
			const name = String(row.name || '').trim();
			if (!name) return null;
			return {
				id: String(employeeId || name || index + 1).trim(),
				employeeId,
				name,
			};
		})
		.filter(Boolean)
		.sort((a, b) => a.name.localeCompare(b.name));

		cachedEmployees = list;
		return cachedEmployees;
	} catch (err) {
		loadError = err;
		throw err;
	}
}

export async function searchEmployees(query) {
	const q = String(query || '').trim().toLowerCase();
	const list = await loadEmployees();
	if (!q) return list.slice(0, 50);
	return list
		.filter(
			(e) =>
				e.name.toLowerCase().includes(q) ||
				(e.employeeId && e.employeeId.toLowerCase().includes(q))
		)
		.slice(0, 50);
}


